var map = {
	"./biography/archive.jpg": 80,
	"./biography/code.jpg": 81,
	"./biography/connection.jpg": 82,
	"./biography/development.jpg": 83,
	"./biography/frontend.jpg": 84,
	"./biography/game.jpg": 85,
	"./biography/keyboard.jpg": 86,
	"./biography/lawyer.jpg": 87,
	"./biography/library.jpg": 88,
	"./biography/net.jpg": 89,
	"./biography/network.jpg": 90,
	"./biography/planning.jpg": 91,
	"./biography/wordpress.jpg": 92,
	"./images/banner-realistic.jpg": 93,
	"./images/banner.jpg": 94,
	"./technologies/png/CSS-3.png": 95,
	"./technologies/png/Express.png": 96,
	"./technologies/png/FileZilla.png": 97,
	"./technologies/png/Git.png": 98,
	"./technologies/png/HTML-5.png": 99,
	"./technologies/png/JSON.png": 100,
	"./technologies/png/JavaScript.png": 101,
	"./technologies/png/Jest.png": 102,
	"./technologies/png/Mongodb.png": 103,
	"./technologies/png/MySQL.png": 104,
	"./technologies/png/Nestjs.png": 105,
	"./technologies/png/Node-JS.png": 106,
	"./technologies/png/PHP.png": 107,
	"./technologies/png/Python.png": 108,
	"./technologies/png/React.png": 109,
	"./technologies/png/Sass.png": 110,
	"./technologies/png/Typescript.png": 111,
	"./technologies/png/VSC.png": 112,
	"./technologies/png/Wordpress.png": 113,
	"./technologies/svg/CSS-3.svg": 114,
	"./technologies/svg/Express.svg": 115,
	"./technologies/svg/FileZilla.svg": 116,
	"./technologies/svg/Git.svg": 117,
	"./technologies/svg/HTML-5.svg": 118,
	"./technologies/svg/JSON.svg": 119,
	"./technologies/svg/JavaScript.svg": 120,
	"./technologies/svg/Jest.svg": 121,
	"./technologies/svg/Mongodb.svg": 122,
	"./technologies/svg/MySQL.svg": 123,
	"./technologies/svg/Nestjs.svg": 124,
	"./technologies/svg/Node-JS.svg": 125,
	"./technologies/svg/PHP.svg": 126,
	"./technologies/svg/Python.svg": 127,
	"./technologies/svg/React.svg": 128,
	"./technologies/svg/Sass.svg": 129,
	"./technologies/svg/Typescript.svg": 130,
	"./technologies/svg/VSC.svg": 131,
	"./technologies/svg/Wordpress.svg": 132,
	"./work/education.svg": 133,
	"./work/finance.svg": 134,
	"./work/javascript.svg": 135,
	"./work/react.svg": 136,
	"./work/review.svg": 137,
	"./work/webdev1.svg": 138,
	"./work/webdev2.svg": 139,
	"./work/website.svg": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;